/* SCALPHY cart drawer extras: reservation timer + upsell add-to-cart + shipping protection */

const RESERVE_KEY = 'scalphy_cart_reserved_until';

class CartReserveTimer extends HTMLElement {
  connectedCallback() {
    const minutes = parseInt(this.dataset.minutes || '10', 10);
    let until = 0;
    try {
      until = parseInt(sessionStorage.getItem(RESERVE_KEY) || '0', 10);
    } catch (e) {}

    if (!until) {
      until = Date.now() + minutes * 60 * 1000;
      try {
        sessionStorage.setItem(RESERVE_KEY, String(until));
      } catch (e) {}
    }

    this.until = until;
    this.timeEl = this.querySelector('[data-time]');
    this.labelEl = this.querySelector('[data-label]');
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const left = Math.max(0, this.until - Date.now());
    const m = Math.floor(left / 60000);
    const s = Math.floor((left % 60000) / 1000);
    if (this.timeEl) this.timeEl.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');

    if (left <= 0) {
      clearInterval(this.interval);
      this.classList.add('is-expired');
      if (this.labelEl) this.labelEl.textContent = 'Complete your order soon';
      if (this.timeEl) this.timeEl.textContent = '';
    }
  }
}

class CartUpsellButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  onClick = async () => {
    const id = Number(this.dataset.variantId);
    if (!id || !this.button) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const original = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Adding...';

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('Add to cart failed');

      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'cart-upsell',
            data: { source: 'cart-upsell', itemCount: cart.item_count },
          },
        })
      );
    } catch (error) {
      console.error(error);
      if (this.button) {
        this.button.disabled = false;
        this.button.textContent = original;
      }
    }
  };
}

class ShippingProtectionToggle extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.input?.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.onChange);
  }

  onChange = async () => {
    const id = Number(this.dataset.variantId);
    if (!id || !this.input) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const adding = this.input.checked;
    this.classList.add('is-loading');

    try {
      const res = await fetch(root + (adding ? 'cart/add.js' : 'cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(adding ? { items: [{ id, quantity: 1 }] } : { updates: { [id]: 0 } }),
      });
      if (!res.ok) throw new Error('Shipping protection update failed');

      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'shipping-protection',
            data: { source: 'shipping-protection', itemCount: cart.item_count },
          },
        })
      );
    } catch (error) {
      console.error(error);
      this.input.checked = !adding;
    } finally {
      this.classList.remove('is-loading');
    }
  };
}

if (!customElements.get('cart-reserve-timer')) customElements.define('cart-reserve-timer', CartReserveTimer);
if (!customElements.get('cart-upsell-button')) customElements.define('cart-upsell-button', CartUpsellButton);
if (!customElements.get('shipping-protection-toggle')) customElements.define('shipping-protection-toggle', ShippingProtectionToggle);
